import { ReactElement, useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { routes } from "routes";
import { DashboardProvider, useDashboardContext } from "./DashboardProvider";
import { DashboardPage } from "./dashboard";
import { Lessons } from "./lessons/lessons";
import { ObjectGategories } from "./object-getagories/object-getagories";
import { Buildings } from "./buildings/buildings";
import { Building } from "./buildings/building";
import { Maps } from "./maps/maps";
import { useSelector } from "react-redux";
import { RootStateType } from "storeRedux/store";
import { UserTypes } from "assets/Roles";
import { AssignedBuildings } from "./assigned-buildings/assigned-buildings";
import { Map } from "./maps/map";
import { AssignedMaps } from "./assigned-maps/assigned-maps";
import { ActiveMaps } from "./active-maps/active-maps";
import { AvatarEditor } from "views/avatar-editor/avatar-editor";




type pages = "dashboard" | "lessons" | "scene-categories" | "buildings" | "maps"|"assigned-buildings"|"active-maps"|"avatar-editor"//|"users"|"maps"|"objects"|"profile-settings"|"materials"
export const ViewDashboard = (): ReactElement => {

    return <div className=" fixed top-0 left-0  h-screen w-screen ">
        <DashboardProvider>
            <Content />
        </DashboardProvider>
        <Outlet />
    </div>
}


const Content = (): ReactElement => {

    const { } = useDashboardContext();

    const navigate = useNavigate();
    const { route, id } = useParams() as { route: pages, id: any };

    const {user} = useSelector((state:RootStateType)=>state.auth);



    const Pages: { [key in pages]?: { page?: ReactElement, item?: ReactElement } } = {
        "dashboard": {
            "page": <DashboardPage />,
        },
        "lessons": {
            "page": <Lessons />
        },
        "scene-categories": {
            "page": <ObjectGategories />
        },

        ...([UserTypes.ACADEMIC,UserTypes.MANAGER] as any ).includes(user?.userType) ?{
            "buildings": {
                "page": <Buildings />,
                "item": <Building />
            },
        }:{},

        ...([UserTypes.MANAGER] as any ).includes(user?.userType) ?{
            "maps": {
                "page": <Maps />,
                "item": <Map />
            }
        }:{},

        
        ...([UserTypes.ACADEMIC] as any ).includes(user?.userType) ?{
            "assigned-maps": {
                "page": <AssignedMaps />,
            }
        }:{},
        
        "avatar-editor": {
            "page": <AvatarEditor />,
        },
        "active-maps": {
            "page": <ActiveMaps />,
        },
        
        ...([UserTypes.STUDENT] as any ).includes(user?.userType) ?{     
            "assigned-buildings":{
                "page":<AssignedBuildings/>
            },
        }:{},

     
        // "users":{
        //     "page":<UserPage/>,
        //     "item":<User/>
        // },
        // "maps":{
        //     "page":<MapsPage/>,
        //     "item":<Map/>
        // },
        // "objects":{
        //     "page":<ObjectsPage/>,
        //     "item":<Object3D/> 
        // },
        // "profile-settings":{
        //     "page":<SettingsPage/>
        // },
        // "materials":{
        //     "page":<MaterialsPage/>,
        //     "item":<Material/>
        // }
    }





    useEffect(() => {

        if (route as pages) {
            !Pages[route] && navigate(routes.dashboard);

        }

    }, [route]);

    return <>
        {Pages[route || "dashboard"]?.[id ? "item" : "page"]}
    </>
}